import httpClient from "@/services/httpClient";
import {
  server
} from "@/services/constants";

export const delete_leaveQHD = (id) => {
    return httpClient.delete(server.LEAVE_HISTORY_QUOTA_DETAIL + `/${id}`);
};